import { ACTIVETAB } from "../actionTypes/BdAction"


export const bd_active_tab = (v) => {
    console.log('bd_active_tab',v)
    return {
        type:ACTIVETAB,
        paylod:v
    }
}